function mmReadMoreAvis(extract, full) {
  var extracts = document.querySelectorAll(extract);
  var fulls = document.querySelectorAll(full);

  for (var i = 0; i < extracts.length; i++) {
    var extract = extracts[i];
    var full = fulls[i];

      if (extract.style.display == 'block') {
          full.style.display = 'block';
          extract.style.display = 'none';
      } else {
          full.style.display = 'none';
          extract.style.display = 'block';
      }
  }
    }
